module.exports = __webpack_public_path__ + "img/flight_takeoff.eebef489.svg";